//@ts-ignore
import { onlyNumeric } from '@origin-digital/normalize';
import { Field } from 'formik';
import React from 'react';

import AddressField from '../AddressField';
import FormRow from '../FormRow';
import HiddenField from '../HiddenField';

import { AddressProps } from './Address.types';

const Address: React.StatelessComponent<AddressProps> = ({ ...props }: AddressProps): JSX.Element => {
  const {
    metaData,
    graphQuery,
    asyncFetching,
    isValid,
    productType,
    setAsyncFetching,
    setDisqualification,
    onGraphError,
    graphError,
    graphMessage,
    onFieldChange,
    recordDisqualification,
    enterAddressManually,
    showManualAddress,
    disqualificationMessage
  } = props;

  return (
    <FormRow
      content={metaData.form.content.propertyAddress}
      byline={metaData.form.content.propertyAddress.byline}
      rowMarginBottom={0}
    >
      <Field
        name={metaData.form.fields.address.name}
        label={metaData.form.fields.address.label}
        metaData={metaData}
        graphQuery={graphQuery}
        component={AddressField}
        showManualAddress={showManualAddress}
        spinner={asyncFetching}
        productType={productType}
        setAsyncFetching={setAsyncFetching}
        enterAddressManually={enterAddressManually}
        setDisqualification={setDisqualification}
        onGraphError={onGraphError}
        graphError={graphError}
        graphMessage={graphMessage}
        onFieldChange={onFieldChange}
        disqualificationMessage={disqualificationMessage}
        recordDisqualification={recordDisqualification}
      />
      <Field
        name={metaData.form.fields.hiddenPostcode.name}
        disqualificationMessage={disqualificationMessage}
        recordDisqualification={recordDisqualification}
        component={HiddenField}
        isValid={isValid}
      />
    </FormRow>
  );
};

export { Address as default };
